import * as React from 'react'
import { useTranslate } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import {
  EVENT_TYPE_DEFAULT_VALUE,
  EVENT_TYPE_FORMS,
  Switch,
} from '../../utils/constants/eventTypeForms'
import SelectEventTypeField from '../SelectEventTypeField/SelectEventTypeField'
import FormContainer from '../layout/FormContainer/FormContainer'
import ButtonWithLoader from '../ui/ButtonWithLoader/ButtonWithLoader'
import ContainerPadding from '../containerPadding/containerPadding'
import PracticeEventForm from '../form/forms/TeamCalendarForms/PracticeEventForm'
import GameEventForm from '../form/forms/TeamCalendarForms/GameEventForm'
import GameFormHeader from '../GameFormLayout/GameFormHeader'
import GameFormFooter from '../GameFormLayout/GameFormFooter'
import ids from '../../utils/constants/introIds'
import mutationType from '../../types/mutationType'
import eventVariantType from '../../types/events/eventVariantType'
import teamType from '../../types/teamType'
import courtType from '../../types/courtType'
import calendarDateClickType from '../../types/calendarDateClickType'
import eventRawType from '../../types/events/eventRawType'
import eventType from '../../types/events/eventType'
import selectEventTypeStyles from './selectEventType.styles'

const SelectEventType = (props) => {
  const {
    selectedEventType,
    event,
    formDirty,
    setFormDirty,
    createEvent,
    updateEvent,
    eventTypes,
    setSelectedEventType,
    clickedEventId,
    currentTeam,
    teams,
    dateClick,
    eventsRaw,
    setEvents,
    disabled,
    courts,
    onCancel,
  } = props
  const translate = useTranslate()
  const useStyles = makeStyles(selectEventTypeStyles)
  const classes = useStyles()

  // const showAnnouncementPostField =

  const formProps = {
    createEvent,
    updateEvent,
    clickedEventId,
    event,
    selectedEventType,
    setFormDirty,
    currentTeam,
    teams,
    dateClick,
    eventsRaw,
    setEvents,
    courts,
  }

  const activeCode = selectedEventType?.code ?? EVENT_TYPE_FORMS.GAME
  const isGame = activeCode === EVENT_TYPE_FORMS.GAME

  // The per-type form switch is identical across branches — extracted so the
  // non-Game branch keeps rendering exactly what it did before.
  const formSwitch = (
    <Switch test={activeCode}>
      <PracticeEventForm value={EVENT_TYPE_FORMS.PRACTICE} {...formProps} />
      <GameEventForm value={EVENT_TYPE_FORMS.GAME} {...formProps} />
    </Switch>
  )

  // Shared submit wiring — identical for the Game footer button and the legacy
  // inline button (same target form, loading and disabled logic).
  const submitLabel = event ? translate('ra.buttons.save') : translate('ra.buttons.create')
  const submitLoading = createEvent.isLoading || updateEvent.isLoading
  const submitDisabled = clickedEventId && !formDirty

  if (isGame) {
    return (
      <ContainerPadding paddingValue='1%' className={classes.gameContainer}>
        <div className={classes.gameHeader}>
          <GameFormHeader
            title={translate('ra.gameDrawer.title')}
            onClose={onCancel}
            // On create, let the user still switch event type (e.g. to Practice); on
            // edit the type is fixed, so show the plain title.
            titleContent={
              clickedEventId ? undefined : (
                <SelectEventTypeField
                  disabled={disabled}
                  eventTypes={eventTypes}
                  selectedEventType={selectedEventType ?? EVENT_TYPE_DEFAULT_VALUE}
                  setSelectedEventType={setSelectedEventType}
                />
              )
            }
          />
        </div>
        <div className={classes.gameScroll}>{formSwitch}</div>
        <div className={classes.gameFooter}>
          <GameFormFooter
            requiredNote={translate('ra.gameDrawer.requiredFields')}
            cancelLabel={translate('ra.action.cancel')}
            submitLabel={submitLabel}
            submitLoading={submitLoading}
            submitDisabled={submitDisabled}
            formId={ids.createEvent.form}
            onCancel={onCancel}
          />
        </div>
      </ContainerPadding>
    )
  }

  return (
    <ContainerPadding paddingValue='1%'>
      <FormContainer>
        <div className={classes.wrapper}>
          <SelectEventTypeField
            disabled={disabled}
            eventTypes={eventTypes}
            selectedEventType={selectedEventType ?? EVENT_TYPE_DEFAULT_VALUE}
            setSelectedEventType={setSelectedEventType}
          />
          <ButtonWithLoader
            label={submitLabel}
            loading={submitLoading}
            disabled={submitDisabled}
            form='my-form'
          />
        </div>
      </FormContainer>
      {formSwitch}
    </ContainerPadding>
  )
}

SelectEventType.propTypes = {
  formDirty: PropTypes.bool,
  clickedEventId: PropTypes.string,
  createEvent: mutationType,
  updateEvent: mutationType,
  eventTypes: PropTypes.arrayOf(eventVariantType),
  event: eventType,
  selectedEventType: eventVariantType,
  setSelectedEventType: PropTypes.func,
  setFormDirty: PropTypes.func,
  currentTeam: teamType,
  teams: PropTypes.arrayOf(teamType),
  dateClick: calendarDateClickType,
  eventsRaw: PropTypes.arrayOf(eventRawType),
  setEvents: PropTypes.func,
  disabled: PropTypes.bool,
  courts: PropTypes.arrayOf(courtType),
  onCancel: PropTypes.func,
}

export default SelectEventType
